import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_TAXES_API_PATHS } from '../constants/taxes-api-paths.constants';

type UseDeleteTaxResult = {
  deleteTax: (taxId: string) => Promise<boolean>;
  isSubmitting: boolean;
};

export function useDeleteTax(): UseDeleteTaxResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteTax = async (taxId: string): Promise<boolean> => {
    setIsSubmitting(true);

    try {
      await HttpClient.delete<void>(ADMIN_TAXES_API_PATHS.DELETE_TAX(taxId));

      enqueueSnackbar('La taxe a été supprimée', { variant: 'success' });
      return true;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la suppression de la taxe'),
        { variant: 'error' }
      );
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { deleteTax, isSubmitting };
}
